import { render, staticRenderFns } from "./movie-order-detail.vue?vue&type=template&id=08db6fed&scoped=true"
import script from "./movie-order-detail.vue?vue&type=script&lang=js"
export * from "./movie-order-detail.vue?vue&type=script&lang=js"
import style0 from "./movie-order-detail.vue?vue&type=style&index=0&id=08db6fed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08db6fed",
  null
  
)

export default component.exports